import {
  getDashboardLink,
  trackDashboardEvent,
} from '@modules/dashboard/helpers';
import { LinkRounded } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useGetUser } from 'v2/core/services/user';
import { useCopyToClipboard } from '@modules/common/hooks';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';

export const DashboardHeaderCopyLinkButton = () => {
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);
  const hasEditAccess = dashboard?.editToken;
  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();
  const copyTextToClipboard = useCopyToClipboard();

  if (!dashboard || hasEditAccess || !dashboard.id) {
    return null;
  }

  const dashboardLink = getDashboardLink(dashboard, tenantSlug);

  const copyDashboardLink = () => {
    copyTextToClipboard(dashboardLink, 'Dashboard link copied to clipboard');
    trackDashboardEvent({
      eventName: 'Dashboard Link Copied',
      dashboardLink,
    });
  };

  return (
    <Tooltip title="Copy Dashboard Link" placement="bottom">
      <IconButton color="primary" onClick={copyDashboardLink}>
        <LinkRounded />
      </IconButton>
    </Tooltip>
  );
};
